import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {TextToHTML} from "@indebted/components/TextToHTML"
import {Page} from "@indebted/components/Page"

function OptOutConfirmed({I18n}: {I18n: {Title: string; Subtitle: string}}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Title}
				</Typography>
			</Grid>
			<Grid>
				<TextToHTML align="center" text={I18n.Subtitle} />
			</Grid>
		</Page>
	)
}

export {OptOutConfirmed}
